module.exports = __webpack_public_path__ + "static/media/landing-ico-3.870eea5c.svg";